import { Billing } from '@/services/api';
import { DidUser } from '@/services/auth';
import theme from '@/theme';
import { PlanGroup, productToProductName } from '@d-id/types';
import styled from '@emotion/styled';
import { ChangePlanData } from './ChangePlanModal';
import { formattedDate } from './utils';

const StyledLine = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 10px;
`;

const LineText = styled.div`
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    :first-letter {
        text-transform: uppercase;
    }
`;

const LineAmount = styled.div<{ bold: boolean; discounted: boolean }>`
    font-style: normal;
    font-weight: ${({ bold }) => (bold ? '700' : '500')};
    color: ${({ discounted }) => (discounted ? '#149260' : theme.colors.black.main)};
    font-size: 16px;
    line-height: 20px;
    padding-left: 1rem;
`;

export const Line = ({
    textLine1,
    textLine2,
    amount,
    discounted,
    isTotalLine = false,
}: {
    amount: number;
    textLine1: string;
    textLine2?: string;
    discounted: boolean;
    isTotalLine?: boolean;
}) => {
    return (
        <StyledLine>
            <LineText>
                {textLine1}
                <br />
                {textLine2}
            </LineText>
            <LineAmount discounted={discounted} bold={!!isTotalLine}>
                ${Math.round(amount * 100) / 100}
            </LineAmount>
        </StyledLine>
    );
};

export const DetailsLines = ({
    changePlanData,
    newInterval,
    discounted,
    user,
}: {
    changePlanData: ChangePlanData;
    newInterval: Billing;
    discounted: boolean;
    user: DidUser;
}) => {
    const intervalText = newInterval === 'month' ? 'Monthly' : 'Annual';

    return (
        <>
            {changePlanData.payments.proration > 0 && (
                <Line
                    discounted={discounted}
                    amount={changePlanData.payments.proration}
                    textLine1={`Prorated charge from ${productToProductName[user?.planGroup as PlanGroup]} (${
                        changePlanData.prevPriceCredits
                    })`}
                />
            )}
            <Line
                discounted={discounted}
                amount={changePlanData.payments.nonProration}
                textLine1={`${intervalText} charge starting ${formattedDate(changePlanData.nextBillingDate)}`}
            />
        </>
    );
};

export const TotalLine = ({ changePlanData, discounted }: { changePlanData: ChangePlanData; discounted: boolean }) => (
    <Line amount={changePlanData.payments.proration} textLine1="Today's charge" isTotalLine={true} discounted={discounted} />
);
